import BlueprintsProvider from './BlueprintsProvider';

export default BlueprintsProvider;
